import { render, staticRenderFns } from "./ProblemasEspecificosAprendizaje.vue?vue&type=template&id=10696858&scoped=true"
import script from "./ProblemasEspecificosAprendizaje.vue?vue&type=script&lang=js"
export * from "./ProblemasEspecificosAprendizaje.vue?vue&type=script&lang=js"
import style0 from "./ProblemasEspecificosAprendizaje.vue?vue&type=style&index=0&id=10696858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10696858",
  null
  
)

export default component.exports